import {Card} from "react-bootstrap";
import React from "react";
import Skeleton from "react-loading-skeleton";

export const SkeletonCard = () => <Card body className="my-3"><Skeleton count={4 + Math.random()}/></Card>;